import { render, staticRenderFns } from "./SpeakApplyMenu.vue?vue&type=template&id=000a6f7c&scoped=true"
import script from "./SpeakApplyMenu.vue?vue&type=script&lang=js"
export * from "./SpeakApplyMenu.vue?vue&type=script&lang=js"
import style0 from "./SpeakApplyMenu.vue?vue&type=style&index=0&id=000a6f7c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "000a6f7c",
  null
  
)

export default component.exports